<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;padding-left:1.2rem;">更多</v-toolbar-title>
    </v-app-bar>
    <v-content>
        <v-container>
            <div v-if="loading" style="margin-top:10rem;">
                <LoadingText />
            </div>
            <div v-else>
              <v-card flat>
                <v-list subheader two-line>
                  <v-list-item class="us-list-item" @click="goOpLogList">
                      <v-list-item-content>
                          <v-list-item-title style="font-size:0.9rem;">操作日志</v-list-item-title>
                          <v-list-item-subtitle class="us-list-item-subtitle">创建工单、浏览记录</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.865rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                  </v-list-item>
                  <v-list-item :disabled="true" class="us-list-item" @click="goAlertComparyName">
                      <v-list-item-content>
                          <v-list-item-title style="font-size:0.9rem;">修改企业名称</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.865rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                  </v-list-item>
                  <v-list-item class="us-list-item" @click="exitCompany">
                      <v-list-item-content>
                          <v-list-item-title style="font-size:0.9rem;">退出企业</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon style="margin:0;margin-left:1rem;">
                        <v-icon color="grey" style="margin-top:0.865rem;">fa fa-angle-right</v-icon>
                      </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-card>
              <SafetyVerifyCode ref="r_safety_verify_code" @verifyed="safetyVerifyed" />
            </div>

        </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
// import SafetyVerifyCode from '../User/components/SafetyVerifyCode'
import SafetyVerifyCode from '../User/components/ConfirmVerifyCode'
export default {
  components: { LoadingText, SafetyVerifyCode },
  props: {},
  data() {
    return {
      companyCode: '',
      companyInfo: {},
      userInfo: {},
      loading: true,
      settDialogVis: false
    }
  },
  computed: {},
  async mounted() {
    var that = this
    that.loading = true
    that.userInfo = that.$AppHelper.getCustomData('user_info');
    that.companyCode = that.$route.query.code
    await that.getCompanyInfo()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goOpLogList() {
      var that = this
      that.$toast.warning('未完成')
    },
    // 获取企业信息
    async getCompanyInfo() {
      var that = this
      if (!that.companyCode) {
        return;
      }
      var res = await that.$api.bz.getCompanyInfo({ code: that.companyCode })
      // console.log('getCompanyInfo.res', res);
      if (!res.success) {
        // that.$toast.warning('获取企业信息失败');
        console.log('获取企业信息失败', res)
        return
      }
      that.companyInfo = res.data
    },
    // 退出企业
    exitCompany() {
      var that = this
      that.$confirm('确定要退出？', '提示').then(async function() {
        var res = await that.$api.bz.exitCompany({ code: that.companyCode })
        if (!res.success) {
          that.$router.goActionResPage({ tag: 0, text: '退出失败', auto_ret: 'b' })
          return
        }
        that.$router.goActionResPage({ tag: 1, text: '退出成功', auto_ret: 'y', dest: -3, refresh: true })
      }, function() {})
    },
    // 删除企业
    async removeCompany() {
      var that = this
      var res = await that.$api.bz.deleteCompany({ code: that.companyCode })
      if (!res.success) {
        that.$router.goActionResPage({ tag: 0, text: '删除失败', auto_ret: 'b' })
        return
      }
      that.$router.goActionResPage({ tag: 1, text: '删除成功', auto_ret: 'y', dest: -3, refresh: true })
    },
    // 修改企业名称
    goAlertComparyName() {
      var that = this
      that.$router.goPage({ path: '/AlertEntName', query: { code: that.companyCode, val: that.companyInfo.COMPANY_NAME }})
    },
    // 删除企业确认
    removeCompanyConfirm() {
      var that = this
      if (that.companyInfo.COMPANY_ADMIN_CODE !== that.userInfo.usercode) {
        that.$toast.warning('只有管理员才可以操作')
        return
      }
      that.$confirm('确定要删除？ 删除后将永久删除不能恢复!', '提示').then(function() {
        that.removeCompanyVerify()
      }, function() {})
    },
    // 删除企业安全验证
    removeCompanyVerify() {
      var that = this
      that.settDialogVis = false
      that.$refs.r_safety_verify_code.show()
    },
    // 安全验证通过
    safetyVerifyed() {
      this.removeCompany()
    }
  }
}
</script>

<style scoped>
.us-list-item{
  min-height:55px;
  max-height:55px;
  padding-right:0.15rem;
  position:relative;
}
.us-list-item-subtitle{
  font-size:0.7rem;
  margin-top:0.2rem;
  padding-right:1.9rem;
  color:#9e9e9e;
}
</style>

